const wowApp = require('angular').module('wowApp.digitalpay');

const DigitalPayPaymentDistributionService = require('./digital-pay-payment-distribution.service');
const DigitalPayPrepaymentActionsService = require('./digital-pay-prepayment-actions.service');
const DigitalPayDisablePaymentStateService = require('./digital-pay-disable-payment-state.service');
const DigitalPayPaymentErrorStateService = require('./digital-pay-payment-error-state.service');

wowApp.service('DigitalPayPaymentDistributionService', DigitalPayPaymentDistributionService);
wowApp.service('DigitalPayPrepaymentActionsService', DigitalPayPrepaymentActionsService);
wowApp.service('DigitalPayDisablePaymentStateService', DigitalPayDisablePaymentStateService);
wowApp.service('DigitalPayPaymentErrorStateService', DigitalPayPaymentErrorStateService);



// WEBPACK FOOTER //
// ./src/digitalpay/services/index.js